Object.defineProperty(exports, '__esModule', { value: true });

const SDK_VERSION = '8.19.0';

exports.SDK_VERSION = SDK_VERSION;
//# sourceMappingURL=version.js.map
